import Vue from 'vue'
import VueMaterial from 'vue-material'
import Vuetify from 'vuetify'
import VueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'
import VueGoogleMaps from 'vue-googlemaps'
import VueHead from 'vue-head'

import dkbrText from '@@/text/vue/Text.vue'
import dkbrTitle from '@@/title/vue/Title.vue'
import dkbrLink from '@@/link/vue/Link.vue'
import dkbrIcon from '@@/icon/vue/Icon.vue'
import dkbrButton from '@@/button/vue/Button.vue'
import dkbrButtonDial from '@@/button/vue/ButtonDial'
import dkbrProgress from '@@/progress/vue/Progress'
import dkbrTooltip from '@@/tooltip/vue/Tooltip'
import dkbrInput from '@@/input/vue/Input'
import dkbrFigure from '@@/figure/vue/Figure'
import dkbrFrame from '@@/frame/vue/Frame'

import 'vue-googlemaps/dist/vue-googlemaps.css'

function comps_() {
    Vue.use(VueMaterial)
    Vue.use(Vuetify)
    Vue.use(VueHead)
    Vue.use(VueMoment)
    Vue.use(VueClipboard)
    Vue.component('dkbr-text', dkbrText)
    Vue.component('dkbr-title', dkbrTitle)
    Vue.component('dkbr-link', dkbrLink)
    Vue.component('dkbr-icon', dkbrIcon)
    Vue.component('dkbr-button', dkbrButton)
    Vue.component('dkbr-button-dial', dkbrButtonDial)
    Vue.component('dkbr-progress', dkbrProgress)
    Vue.component('dkbr-tooltip', dkbrTooltip)
    Vue.component('dkbr-input', dkbrInput)
    Vue.component('dkbr-figure', dkbrFigure)
    Vue.component('dkbr-frame', dkbrFrame)
    Vue.use(VueGoogleMaps, {
      load: {
        apiKey: 'AIzaSyB0HvlqbtfXpnS1rO4xMxXzPVrGQlWoVYA',
        libraries: ['places'],
      },
    })
}

Vue.prototype.$bus = new Vue({
    methods: {
        on(name, func) {
            return this.$on(name, func)
        },
        once(name) {
            return this.$once(name)
        },
        off(name, func) {
            return this.$off(name, func)
        },
        emit(name) {
            return this.$emit(name)
        }
    }
})

export default comps_



// WEBPACK FOOTER //
// ./main/components.js